import React from "react";
import { Helmet } from "react-helmet-async";
import { useApp } from "../context/AppContext";

const SITE = "https://cockpit-os.com";

// Client-side <head> management so SPA navigation keeps the tab title / canonical / meta
// correct after hydration. The server already injects route SEO for crawlers; this keeps
// the live browser experience and social-share previews in sync per language.
export default function Seo({ path = "/", title, description, noindex = false }) {
  const { lang } = useApp();
  const canonical = path === "/" ? SITE : `${SITE}${path}`;
  return (
    <Helmet>
      <html lang={lang} />
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonical} />
      {noindex
        ? <meta name="robots" content="noindex, nofollow" />
        : <meta name="robots" content="index, follow, max-image-preview:large" />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={lang === "fr" ? "fr_FR" : "en_US"} />
    </Helmet>
  );
}
